<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <component :is="componentType" class="tile" v-bind="{ ...propTypes }">
      <ImageCard>
        <template #image="{widthView}">
          <cloudinary-image
            aspect-ratio="1/1"
            :image-alt="imageAlt"
            :image-source="imageSrc"
            :fraction="widthView"
          />
        </template>
        <template #title>
          <sh-heading
            type="h3"
            size-desktop="size-5"
            size-mobile="size-5"
          >
            {{ title }}
          </sh-heading>
        </template>
        <template #default>
          <sh-button :naked="true">{{ linkText }}</sh-button>
        </template>
      </ImageCard>
    </component>
  </sc-render>
</template>

<script>
import { ImageCard, Heading } from '@sohohouse/design-system'
import { createNamespacedHelpers } from 'vuex'

import ShLink from '~/components/sh-link'
import ScRender from '../sc-render'
import CloudinaryImage from '~/components/cloudinary-image'

import mapFields from '~/helpers/map-fields'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'AutomatedCarouselTile',

  components: {
    ShHeading: Heading,
    ImageCard,
    ShLink,
    ScRender,
    CloudinaryImage
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapFields({
      imageSrc: 'thumbnailImage.value.cloudinary_1x1_fill_crop',
      imageAlt: 'thumbnailImage.value.alt',
      title: 'title.value',
      linkHref: 'source.value',
      linkText: 'pageAction.fields.text.value'
    }),

    componentType () {
      if (this.isEditMode) return 'div'

      return 'sh-link'
    },

    propTypes () {
      if (this.componentType === 'div') return {}

      return { to: this.linkHref }
    }
  }
}
</script>

<style lang="scss" scoped>
.tile {
  text-decoration: none;
}
</style>
